<template>
  <div class="essay-page">
    <div class="conditions">
      <div class="inner">
        <div class="head" style="fontsize: 20px">论文发现</div>
        <a-row :gutter="[20, 20]">
          <a-col :span="3"></a-col>
          <a-col :span="16">
            <a-input-group compact>
              <a-select v-model:value="type" style="width: 100px;">
                <a-select-option
                  v-for="item in types"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
                <template #suffixIcon><caret-down-outlined /></template>
              </a-select>
              <a-input
                style="width: calc(100% - 100px);"
                v-model:value="keyword"
                placeholder="请输入搜索内容"
              />
            </a-input-group>
          </a-col>
          <a-col :span="2">
            <a-button
              type="primary"
              v-if="conditions.length === 0"
              @click="goFilter"
              style="
                width: 80px;
                background-color: #ffc842;
                border-color: #ffc842;
                margin-left: -10px;
              "
              >检索</a-button
            >
          </a-col>
          <a-col :span="3">
            <a-button
              type="link"
              v-if="conditions.length === 0"
              @click="reset"
              style="color: #fff;margin-left: -10px;"
              >重置</a-button
            >
          </a-col>
        </a-row>
        <div class="more-conditons" v-if="conditions.length > 0">
          <div class="item" v-for="(item, key) in conditions" :key="item.key">
            <a-row :gutter="[20, 20]">
              <a-col :span="3">
                <a-select v-model:value="item.joinName" style="width: 100px;margin-left:17px">
                  <a-select-option :value="0">AND</a-select-option>
                  <a-select-option :value="1">OR</a-select-option>
                  <a-select-option :value="2">NOT</a-select-option>
                  <template #suffixIcon><caret-down-outlined /></template>
                </a-select>
              </a-col>
              <a-col :span="16">
                <a-input-group compact>
                  <a-select v-model:value="item.type" style="width: 100px">
                    <a-select-option
                      v-for="i in types"
                      :key="i.value"
                      :value="i.value"
                      >{{ i.name }}</a-select-option
                    >
                    <template #suffixIcon><caret-down-outlined /></template>
                  </a-select>
                  <a-input
                    style="width: calc(100% - 100px)"
                    v-model:value="item.keyword"
                    placeholder="请输入搜索内容"
                  />
                </a-input-group>
              </a-col>
              <a-col :span="2" class="icons" style="color: #fff;margin-left: -14px;">
                <minus-circle-outlined @click="removeCondition(key)" />
                <plus-circle-outlined
                  @click="addCondition"
                  v-if="key === conditions.length - 1 && conditions.length < 4"
                />
              </a-col>
              <a-col :span="3"> </a-col>
            </a-row>
          </div>
          <div class="item">
            <a-row :gutter="[20, 20]">
              <a-col :span="3" style="line-height: 32px; color: white;padding-left:42px">
                发表年份：
              </a-col>
              <a-col :span="7">
                <a-date-picker
                  v-model:value="startTime"
                  style="width: 100%"
                  format="YYYY"
                  valueFormat="YYYY"
                  picker="year"
                  mode="year"
                  :open="open1"
                  @panelChange="(e)=>{panelChange(e,1)}"
                  @focus="open1=!open1"
                />
              </a-col>
              <a-col :span="2" style="text-align: center; color: #fff">
                ——
              </a-col>
              <a-col :span="7">
                <a-date-picker
                  v-model:value="endTime"
                  style="width: 100%"
                  format="YYYY"
                  valueFormat="YYYY"
                  picker="year"
                  mode="year"
                  :open="open2"
                  @panelChange="(e)=>{panelChange(e,2)}"
                  @focus="open2=!open2"
                />
              </a-col>
              <a-col :span="2" class="icons">
                <a-button
                  type="primary"
                  @click="goFilter"
                  style="
                    width: 80px;
                    background-color: #ffc842;
                    border-color: #ffc842;
                    margin-left: -10px;
                  "
                  >检索</a-button
                >
              </a-col>
              <a-col :span="3">
                <a-button type="link" @click="reset" style="color: #fff;margin-left: -10px;"
                  >重置</a-button
                >
              </a-col>
            </a-row>
          </div>
        </div>
        <div
          class="more-conditions"
          style="text-align: center; padding-top: 10px; color: #fff"
        >
          <up-outlined
            class="get-more-btn"
            v-if="conditions.length > 0"
            @click="hideMoreConditon"
          />
          <down-outlined class="get-more-btn" v-else @click="showMore" />
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
} from "vue";
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  DownOutlined,
  CaretDownOutlined,
  UpOutlined,
} from "@ant-design/icons-vue";
import { messageTips } from "../../until/tools";
import { useRouter, useRoute } from "vue-router";
import config from "../../until/configs";

function CreateConditon(key,name) {
  this.key = key;
  this.joinName = 0;
  this.type = name||'topicsName';
  this.keyword = "";
}

export default defineComponent({
  components: {
    MinusCircleOutlined,
    PlusCircleOutlined,
    DownOutlined,
    CaretDownOutlined,
    UpOutlined,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      type: "topicsName",
      types: [
        { name: "主题词", value: "topicsName" },
        { name: "作者", value: "author" },
        { name: "标题", value: "title" },
        { name: "文献来源", value: "source" },
        { name: "关键词", value: "newKeyword" },
      ],
      keyword: "",
      conditions: [],
      startTime: undefined,
      endTime: undefined,
      open1:false,
      open2:false
    });
    const typeObj = {
      topicsName: "主题词",
      author: "作者",
      title: "标题",
      source: "文献来源",
      keyword: "关键词",
    };

    const skip = computed(() => {
      return route.query.skip;
    });

    const removeCondition = (key) => {
      let arr = [...state.conditions];
      arr.splice(key, 1);
      Object.assign(state, {
        conditions: arr,
      });
    };

    const addCondition = () => {
      let obj = new CreateConditon(parseInt(Math.random() * 10000));
      let arr = [...state.conditions, obj];
      Object.assign(state, {
        conditions: arr,
      });
    };

    const showMore = () => {
      Object.assign(state, {
        conditions: [new CreateConditon(parseInt(Math.random() * 10000),'author'),new CreateConditon(parseInt(Math.random() * 10000),'source')],
      });
    };

    const hideMoreConditon = () => {
      Object.assign(state, {
        conditions: [],
      });
    };

    const reset = () => {
      Object.assign(state, {
        startTime: undefined,
        endTime: undefined,
        type: "topicsName",
        keyword: "",
      });
      // state.conditions.forEach((item) => {
      //   item.keyword = "";
      //   item.joinName = 0;
      // });
      state.conditions = [];
      if (route.path === "/essay_filter") {
        router.push({
          path: "/essay_collection",
        });
      }
    };

    const goFilter = () => {
      if(state.keyword==''&&state.startTime==undefined&&state.endTime==undefined) {
        messageTips('未输入内容',2)
        return false;
      }
      let arr = [
        { keyword: state.keyword, type: state.type },
        ...state.conditions,
      ];

      if (arr.length > 1) {
        let isRepeat = {};
        arr.forEach((item) => {
          if (isRepeat[item.type]) {
            isRepeat[item.type] += 1;
          } else {
            isRepeat[item.type] = 1;
          }
        });
        let repeatType = null;
        for (let i in isRepeat) {
          if (isRepeat[i] > 1) {
            repeatType = i;
            break;
          }
        }
        if (repeatType) {
          messageTips("不能同时检索多个" + typeObj[repeatType], 2);
          return false;
        }
      }

      let conditions = JSON.stringify(arr);
      router.push({
        path: "/essay_filter",
        query: {
          conditions,
          startTime: state.startTime,
          endTime: state.endTime,
          page: 1,
        },
      });
    };

    const panelChange = (e,type)=>{
      if(type===1) {
        Object.assign(state,{
          startTime:e.years().toString(),
          open1:false
        })
      } else {
        Object.assign(state,{
          endTime:e.years().toString(),          
          open2:false
        })
      }
    }


    watch(skip, () => {
      initCondition();
    });

    onMounted(() => {
      document.title = "论文发现-" + config.siteTitle;
      initCondition();
    });

    const initCondition = () => {
      let conditions = route.query.conditions;
      if (conditions) {
        try {
          conditions = JSON.parse(conditions);
        } catch (error) {
          if (error) {
            messageTips("数据格式错误", 1);
            return false;
          }
        }
      } else {
        return false;
      }
      let item = conditions.shift();
      Object.assign(state, {
        keyword: item.keyword,
        type: item.type,
        conditions: conditions,
        startTime: route.query.startTime || undefined,
        endTime: route.query.endTime || undefined,
      });
    };

    return {
      ...toRefs(state),
      removeCondition,
      addCondition,
      showMore,
      hideMoreConditon,
      goFilter,
      reset,
      panelChange,
    };
  },
});
</script>

<style lang="scss">
@import "../../scss/essay.scss";
</style>
<style lang="scss" scoped>
.ant-input {
  background-color: #fff;
  border: 1px solid #ccc;
}
/deep/.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #aaa;
}
/deep/.ant-select:not(.ant-select-disabled):focus .ant-select-selector {
  border-color: #aaa;
}
/deep/.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  box-shadow: none;
}
</style>